import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BusinessReducer(state = initialState.business, action: any) {
  switch (action.type) {
    case types.SAVE_BUSINESS_SUCCESS:
      return action.business;
    default:
      return state;
  }
}
